import { createLogger } from '@yoti-web-share/logger'

export const logger = createLogger('bridge', { prefix: `bridge-${window.location.href}` })
